"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "copparo": {
    "ae85c26a": [{
      "hkey": "c2b5d649",
      "slug": "ca-matte",
      "name": "Ca' Matte",
      "primary": true,
      "skipSearch": false
    }],
    "saletta-ca-matte": [{
      "hkey": "c2b5d649",
      "slug": "ca-matte",
      "name": "Ca' Matte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "dcc268b9": [{
      "hkey": "31523c80",
      "slug": "la-saletta-tamara",
      "name": "La Saletta-Tamara",
      "primary": true,
      "skipSearch": false
    }],
    "tamara": [{
      "hkey": "31523c80",
      "slug": "la-saletta-tamara",
      "name": "La Saletta-Tamara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;